import React from 'react';

import { RootStyled } from './styles';
import { SkeletonProps } from './types';

export const Skeleton = (props: SkeletonProps): JSX.Element => <RootStyled {...props} />;
